import { render, staticRenderFns } from "./WaitingSigned8821.vue?vue&type=template&id=010325b0&scoped=true&"
import script from "./WaitingSigned8821.vue?vue&type=script&lang=js&"
export * from "./WaitingSigned8821.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010325b0",
  null
  
)

export default component.exports